<template>
  <div class="main">
    <div class="d-flex justify-space-between align-center">
      <div class="d-flex align-start">
        <div>{{ index }}. {{ question.title }}</div>
        <v-icon v-if="question.required" color="red" size="7" class="mr-4 mt-1">mdi-asterisk</v-icon>
      </div>
      <div v-if="showAction">
        <v-icon left color="primary" class="pointer" @click="() => $refs.questionDialog.openDialog('update', question)"
          >mdi-pencil</v-icon
        >
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title style="cursor: pointer" @click="removeQuestion(question.id)">
                <v-icon left color="error" class="ml-2 pointer">mdi-delete</v-icon>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <div>
      <div class="answer">
        <div v-if="question.type === 'text'">
          <v-text-field value="Văn bản câu trả lời" hide-details disabled></v-text-field>
        </div>
        <div v-if="question.type === 'single'">
          <v-radio-group class="ma-0 pa-0" hide-details>
            <v-radio disabled v-for="answer in question.answers" :key="answer.id" :label="answer.title"></v-radio>
          </v-radio-group>
        </div>
        <div v-if="question.type === 'multiple'">
          <v-checkbox
            v-for="answer in question.answers"
            :key="answer.id"
            hide-details
            class="mt-2"
            :label="answer.title"
            disabled
          ></v-checkbox>
        </div>
      </div>
    </div>
    <QuestionDialog ref="questionDialog" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import QuestionDialog from './QuestionDialog.vue'
export default {
  components: { QuestionDialog },
  props: {
    question: {
      type: Object,
      default: () => ({})
    },
    showAction: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState({
      questions: state => state.survey.questions
    })
  },
  methods: {
    ...mapActions({
      fetch: 'surveyQuestion/fetch',
      remove: 'surveyQuestion/remove'
    }),
    async removeQuestion(id) {
      this.$dialog.confirm({
        title: 'Xoá câu hỏi',
        text:
          'Xoá câu hỏi sẽ <span style="color: red">xoá dữ liệu báo cáo</span> của câu hỏi này <br> Bạn có muốn xoá câu hỏi?',
        okText: 'Xoá',
        cancelText: 'Hủy',
        type: 'delete',
        done: async () => {
          try {
            this.$loading.active = true
            await this.remove(id)
            this.$alert.success('Xoá thành công')
            this.fetch({ survey: this.$route.params.id })
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    }
  }
}
</script>

<style>
.pointer {
  cursor: pointer;
}
.main {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
}
.answer {
  margin-top: 8px;
  min-width: 200px;
  max-width: 95%;
}
</style>
